// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ds2-5-modal__content.LoginModal-nogap___c74b16a2955bd8e51d9{grid-gap:0px;gap:0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nogap": "LoginModal-nogap___c74b16a2955bd8e51d9"
};
export default ___CSS_LOADER_EXPORT___;
